export default __webpack_public_path__ + "static/media/entertainmenthub.8e2bcfab.png";